import type { FaireCollectionEntity } from "../../entity_types/collection";

export const pbc_6ztgrsbj4t: FaireCollectionEntity = {
  token: "pbc_6ztgrsbj4t",
  type: "collection",
  name: "SS26 Bonbon Soleil Organic Sweater Knits",
  heroImageUrl:
    "https://cdn.faire.com/fastly/7865f4cf88d42c88423888e3bdf2ed20adaba892bf0e277bdf9c81c265c1f312.jpeg",
  itemCount: 52,
  description:
    "Introducing our eco-chic baby sweater knits, thoughtfully crafted from 100% certified organic cotton for the ultimate blend of style, comfort, and sustainability.",
  brandToken: "b_7fghelgl",
  productTokens: [],
  meta: {
    source: "api",
    importedAt: "2026-08-11T04:59:17.570Z",
    importedBy: "entity-db-import-collections",
  },
};
